import { ORDER_STATUSES, ORDER_STATUS_LABEL } from '@nsd/core';
import { Link } from 'react-router-dom';
import { ErrorBox, Loading, Money, Panel, api, useLoad } from '../ui.tsx';
import { OrderList } from './Orders.tsx';

export function Dashboard() {
  const { data, error, loading } = useLoad(() => api.stats());
  if (loading && !data) return <Loading />;
  if (!data) return <ErrorBox error={error} />;
  return (
    <>
      <h1>Dashboard</h1>
      <div className="kpis">
        <Link className="kpi kpi--alert" to="/orders?status=pending_payment">
          <span>Awaiting e-Transfer</span>
          <strong>{data.byStatus.pending_payment}</strong>
          <small><Money cents={data.awaitingCents} /></small>
        </Link>
        <Link className="kpi" to="/orders?status=paid">
          <span>Paid, to ship</span>
          <strong>{data.byStatus.paid + data.byStatus.processing}</strong>
        </Link>
        <div className="kpi">
          <span>Paid revenue, 30 days</span>
          <strong><Money cents={data.revenue30Cents} /></strong>
          <small>{data.orders30} orders placed</small>
        </div>
        <div className="kpi">
          <span>All orders</span>
          <strong>{data.totalOrders}</strong>
        </div>
      </div>
      {data.lowStock.length > 0 && (
        <div className="notice notice--warn">
          Low stock: {data.lowStock.map((p) => `${p.name} (${p.stock})`).join(', ')}. <Link to="/products">Update stock</Link>
        </div>
      )}
      <Panel title="Recent orders" actions={<Link to="/orders">All orders</Link>}>
        <OrderList orders={data.recent} />
      </Panel>
      <Panel title="By status">
        <div className="chips">
          {ORDER_STATUSES.map((s) => (
            <Link key={s} className="chip" to={`/orders?status=${s}`}>
              {ORDER_STATUS_LABEL[s]} <b>{data.byStatus[s]}</b>
            </Link>
          ))}
        </div>
      </Panel>
    </>
  );
}
